<script setup lang="ts">
defineProps<{
  color: string;
}>();
</script>
<template>
  <div class="color-render" :style="{ backgroundColor: `var(--status-${color})` }"></div>
</template>
<style lang="scss">
.color-render {
  height: 20px;
  width: 20px;
  border-radius: 4px;
}
</style>
